var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-split-container"},[_c('div',{staticClass:"data-input-wrap",class:{white:_vm.white}},[_vm._t("input-list")],2),_vm._t("right")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }